import { PropsWithChildren } from 'react';
import formStyles from '../../../shared/ui-components/Form/Form.module.scss';

export const FormRow = ({ children }: PropsWithChildren<unknown>): JSX.Element => {
    return <div className={formStyles._formContainer}>{children}</div>;
};
